// extracted by mini-css-extract-plugin
export default {"modal-save-filters":"styles_modal-save-filters__MKSaR"};